// extracted by mini-css-extract-plugin
export default {"overlay":"_xpJkc","suggestions-shown":"JK71Yc","suggestionsShown":"JK71Yc","form-container":"oRg3Ie","formContainer":"oRg3Ie","suggestions":"UaSQpI"};